import { LANG } from "~/enums/Lang";

export default defineNuxtRouteMiddleware((to, from) => {
  const cookieLocale = useCookie('locale');
  const supportedLocales = [
    'en', 'ar', 'ru', 'cs', 'da', 'bg', 'nl', 'et', 'de', 'uk',
    'es', 'tr', 'zh', 'pt', 'fi', 'fr', 'el', 'hu', 'id', 'it',
    'ja', 'ko', 'lv', 'lt', 'nb', 'pl', 'ro', 'sk', 'sl', 'sv'
  ];

  const isSupportedLocalePath = () => {
    return supportedLocales.some(locale => to.path.startsWith(`/${locale}`));
  };

  // Проверка локали в пути
  if (isSupportedLocalePath()) {
    const currentLocale = supportedLocales.find(locale => to.path.startsWith(`/${locale}`));
    if (cookieLocale.value !== currentLocale) {
      cookieLocale.value = currentLocale;
    }
    return; // Если путь уже содержит локаль, редирект не требуется
  }

  // Этот код выполняется только на сервере
  if (process.server) {
    // Получаем заголовок "accept-language" для определения локали
    const localeFromBrowser = useRequestHeaders()['accept-language']?.split(',')[0].slice(0, 2);

    // Выбираем локаль: из куки или из заголовков браузера
    const basedLocale = cookieLocale.value || (supportedLocales.includes(localeFromBrowser) ? localeFromBrowser : LANG.EN);

    // Если текущий путь не содержит локаль, делаем редирект
    if (!to.path.startsWith(`/${basedLocale}`)) {
      return navigateTo(`/${basedLocale}${to.fullPath}`);
    }
  }
});